// v2/utils/ses.js — v2 sesli bildirimler (Web Audio API; dosya indirmez)
// Tarayicilar kullanici etkilesimi olmadan ses calinmasina izin vermez: ilk tiklama /
// tus basiminda ses baglami "uyandirilir". Tercih (acik/kapali, seviye) localStorage'da.
// Musteri sesleri: sepet (pop), basari (siparis alindi), hata (siparis verilemedi).
// Admin kasa sesi ayri: utils/kasaSesi.js (dosyadan calar).

const AYAR_KEY = 'v2_ses_ayar';
const VARSAYILAN = { acik: true, seviye: 0.7 };

let ctx = null;
let ana = null;
const dinleyiciler = new Set();

function ayarOku() {
  try {
    const a = JSON.parse(window.localStorage.getItem(AYAR_KEY) || 'null');
    if (a && typeof a.acik === 'boolean') {
      const sev = Number(a.seviye);
      return {
        acik: a.acik,
        seviye: Number.isFinite(sev) ? Math.min(1, Math.max(0, sev)) : VARSAYILAN.seviye,
      };
    }
  } catch (e) { /* bozuk kayit: varsayilan */ }
  return { ...VARSAYILAN };
}

let ayar = typeof window !== 'undefined' ? ayarOku() : { ...VARSAYILAN };

export function sesAyari() {
  return ayar;
}

export function sesAyarla(yeni) {
  ayar = { ...ayar, ...yeni };
  try { window.localStorage.setItem(AYAR_KEY, JSON.stringify(ayar)); } catch (e) { /* yok say */ }
  if (ana) ana.gain.value = ayar.seviye;
  dinleyiciler.forEach((fn) => { try { fn(ayar); } catch (e) { /* yok say */ } });
}

export function sesAbone(fn) {
  dinleyiciler.add(fn);
  return () => dinleyiciler.delete(fn);
}

function baglam() {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try {
      ctx = new AC();
      const sikistirici = ctx.createDynamicsCompressor();
      sikistirici.threshold.value = -18;
      sikistirici.knee.value = 12;
      sikistirici.ratio.value = 4;
      ana = ctx.createGain();
      ana.gain.value = ayar.seviye;
      ana.connect(sikistirici);
      sikistirici.connect(ctx.destination);
    } catch (e) {
      ctx = null;
      ana = null;
      return null;
    }
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

/** Ses baglamini hazirlar (kullanici etkilesimi icinde cagrilmali). */
export function sesiUyandir() {
  baglam();
}

// ilk etkilesimde baglami bir kez ac
if (typeof window !== 'undefined') {
  const uyandir = () => {
    baglam();
    window.removeEventListener('pointerdown', uyandir, true);
    window.removeEventListener('keydown', uyandir, true);
  };
  window.addEventListener('pointerdown', uyandir, true);
  window.addEventListener('keydown', uyandir, true);
}

/** Tek nota: yumusak atak + ustel sonumleme (tiklama sesi olmaz) */
function nota(c, { frekans, bitisFrekans, baslangic = 0, sure = 0.18, tip = 'sine', guc = 0.3, atak = 0.008 }) {
  const t0 = c.currentTime + baslangic;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = tip;
  osc.frequency.setValueAtTime(frekans, t0);
  if (bitisFrekans) osc.frequency.exponentialRampToValueAtTime(bitisFrekans, t0 + sure * 0.8);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(guc, t0 + atak);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + sure);
  osc.connect(g);
  g.connect(ana);
  osc.start(t0);
  osc.stop(t0 + sure + 0.02);
  osc.onended = () => { try { osc.disconnect(); g.disconnect(); } catch (e) { /* yok say */ } };
}

function cal(fn) {
  if (!ayar.acik) return;
  const c = baglam();
  if (!c || !ana) return;
  try { fn(c); } catch (e) { /* ses hatasi akisi bozmasin */ }
}

const ses = {
  /** Sepete ekleme: kisa, yumusak "pop" */
  sepet: () => cal((c) => {
    nota(c, { frekans: 520, bitisFrekans: 880, sure: 0.12, tip: 'sine', guc: 0.28 });
    nota(c, { frekans: 1320, baslangic: 0.06, sure: 0.14, tip: 'triangle', guc: 0.1 });
  }),

  /** Siparis alindi: yukselen dort nota (Do-Mi-Sol-Do) + hafif parilti */
  basari: () => cal((c) => {
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      nota(c, { frekans: f, baslangic: i * 0.09, sure: 0.32 + i * 0.06, tip: 'triangle', guc: 0.22 });
      nota(c, { frekans: f * 2, baslangic: i * 0.09, sure: 0.2, tip: 'sine', guc: 0.05 });
    });
  }),

  /** Islem basarisiz: alcak, inen iki nota (rahatsiz etmeyen) */
  hata: () => cal((c) => {
    nota(c, { frekans: 392, sure: 0.18, tip: 'triangle', guc: 0.22 });
    nota(c, { frekans: 311.13, baslangic: 0.14, sure: 0.3, tip: 'triangle', guc: 0.2 });
  }),
};

export default ses;
